// @flow @jsx h
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable promise/always-return */

import { Component, h } from 'preact'
import { bem } from '@nrk/dh-utils'
import { sendQuestion } from '../../../lib/feed'

/* styles */
import styles from './index.css'
import appStyles from '../App.css'

type Props = {
  feedId: string
}

type State = {
  formState: 'input' | 'submitting' | 'submitted' | 'failed',
  submitted: boolean,
  fromName: string,
  text: string
}

export class QuestionForm extends Component<Props, State> {
  constructor () {
    super()
    this.state = { formState: 'input', fromName: '', text: '' }
  }

  handleShowFormClick = (event) => {
    this.setState({ formState: 'input' })
  }

  handleTextChange = (event) => {
    this.setState({ text: event.target.value })
  }

  handleFromNameChange = (event) => {
    this.setState({ fromName: event.target.value })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.setState({ submitted: true })
    if (this.state.fromName && this.state.text) {
      this.setState({ formState: 'submitting' })

      sendQuestion(this.props.feedId, this.state.fromName, this.state.text)
        .then(() => {
          this.setState({ formState: 'submitted' })
        })
        .catch(() => {
          this.setState({ formState: 'failed' })
        })
    }
  }

  renderForm (isSubmitting) {
    return <div class={styles.form__container + ' ' + appStyles.app__element}>
      <h2>Send inn spørsmål</h2>
      <p>Krimjournalistene i VG og NRK svarer på spørsmål i perioden der serien «Gåten Orderud» sendes.</p>
      <form onSubmit={this.handleSubmit} class={styles.form}>
        <div>
          <div>
            <label htmlFor='fromName' class='nrk-sr'>
              Fra
            </label>
            <input
              type='text'
              name='fromName'
              id='fromName'
              placeholder={'Fra'}
              disabled={isSubmitting}
              onChange={this.handleFromNameChange} />
          </div>
          {
            !this.state.fromName && this.state.submitted && (
              <div class={styles.error}>Hva er navnet ditt?</div>
            )
          }
        </div>
        <div>
          <div>
            <label htmlFor='text' class='nrk-sr'>
              Spørsmål
            </label>
            <textarea
              name='text'
              id='text'
              onChange={this.handleTextChange}
              placeholder='Forklar hva du lurer på...'
              rows='5'
              disabled={isSubmitting}
            />
          </div>
          {
            !this.state.text && this.state.submitted && (
              <div class={styles.error}>Skriv spørsmålet ditt her.</div>
            )
          }
        </div>
        <div class={styles.form__buttons}>
          <button
            type='submit'
            class={'nrk-button' + (isSubmitting ? ' is-busy' : '')}
            disabled={isSubmitting}
          >
            Send&nbsp;
            <svg class='nrk-fade' width='30' height='30' aria-hidden='true'>
              <use xlinkHref='#nrk-arrow-right-long' />
            </svg>
          </button>
        </div>
      </form>
    </div>
  }

  renderSubmitted () {
    return <div class={bem(styles.form__container, { submitted: true }) + ' ' + appStyles.app__element}>
      <p>Takk for at du sendte inn spørsmål. Vi vil svare deg så fort vi kan.</p>

      <p><a href='https://www.nrk.no/orderud/orderud-_-sporsmal-og-svar-1.14242569'>Her finner du spørsmålene som
        allerede er besvart.</a> Kanskje får du svar på noe annet du lurte på.</p>
    </div>
  }

  render () {
    switch (this.state.formState) {
      case 'input':
        return this.renderForm(false)
      case 'submitting':
        return this.renderForm(true)
      case 'submitted':
        return this.renderSubmitted()
      case 'failed':
      default:
        return <div class={styles.error}>En feil har oppstått. Prøv igjen senere.</div>
    }
  }
}
